import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlugin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"plugin-2, build"} maskId="square-filled-radius-0-stroke-1-IconPlugin2"><path d="M4 3H11V7H4V3Z" fill="currentColor"/><path d="M13 3H20V7H13V3Z" fill="currentColor"/><path d="M2 8H22V20H2V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPlugin2;
